

const state = () => ({
    users: [],
    user: null,
    successfullysave: false,
    hasErrorInService: false,
    lastErrorInService: '',
    lastErrorInServiceDetails: null
})

export default state
